import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import LoadingSpinner from "../components/LoadingSpinner";

class MatrixTimeToTriggerTable extends Component {
    render() {
        const {
            devicesShowing,
            zonesShowing,
            triggers,
            triggerCounts,
            displayAsIcons,
            showSinglePercentage,
            isLoading,
            toggleSelectDevice,
            toggleSelectZone,
            tttMetric
        } = this.props;

        if (!devicesShowing.length || !zonesShowing.length) {
            if (isLoading) {
                return (
                    <div className="matrix-table">
                        <h4>
                            <LoadingSpinner />
                        </h4>
                    </div>
                );
            } else {
                return (
                    <div className="matrix-table">
                        <h4>Select at least one zone and one device to display matrix.</h4>
                    </div>
                );
            }
        }

        let zoneWindows = calculateZoneWindows(triggers, zonesShowing, tttMetric)

        const somethingSelected = devicesShowing.some(({ isSelected }) => isSelected) || zonesShowing.some(({ isSelected }) => isSelected);

        let tableDisplay
        let  deviceNamesDisplay = [<td key="top-left-corner" />];

        // Add device names to top row
        devicesShowing.forEach(device =>
            deviceNamesDisplay.push(
                <td
                    key={`ttt-device-name-${device._id}`}
                    className={`clickable ${device.isSelected || !somethingSelected ? `bold` : `grey`}`}
                    onClick={() => toggleSelectDevice(device._id)}
                >
                    {device.name}
                </td>
            )
        );

        // Summary cols
        deviceNamesDisplay.push(
            [
                <td key="ttt-summary-early" className="bold">Early</td>,
                <td key="ttt-summary-on-time" className="bold">On Time</td>,
                <td key="ttt-summary-late" className="bold">Late</td>
            ]
        )

        let countSingleHits = Object.values(triggerCounts.device).map(item => item.single).reduce((prev, next) => prev + next);

        // Main table
        const fullTimeList = [];
        let totalEarly = 0, totalOnTime = 0, totalLate = 0;
        tableDisplay = zonesShowing.map(zone => {
            const zoneWindow = zoneWindows[zone._id];
            let rowTimeList= []
            let mainRowDisplay = devicesShowing.map(device => {
                const triggerList = triggers.filter(trigger => (trigger.deviceId === device.identifier || trigger.deviceId === device._id) && trigger.zoneId === zone._id);
                let trigger = null, triggerTime = null;
                if( triggerList.length ) {
                    trigger = triggerList[0];
                    if( tttMetric == "eventTime" )
                        triggerTime = new Date(trigger.eventTime).getTime();
                    else
                        triggerTime = new Date(trigger.receivedAt).getTime();
                    rowTimeList.push(triggerTime-zoneWindow);
                    fullTimeList.push(triggerTime-zoneWindow);
                } else {

                }

                let colour,
                    triggerIcon,
                    triggerType,
                    bold = true;

                if( trigger !== null ) {
                    if (triggerTime < zoneWindow + 5000) {
                        colour = "green";
                        triggerIcon = "ok-sign";
                        triggerType = "On time";
                    } else {
                        colour = "red";
                        triggerIcon = "remove-sign";
                        triggerType = "Late";
                    }
                    if (triggerTime < zoneWindow) {
                        colour = "orange";
                        triggerIcon = "exclamation-sign";
                        triggerType = "Early";
                    }
                } else {
                    colour = "black";
                    triggerIcon = "exclamation-sign";
                    triggerType = "N/A";
                }

                if (somethingSelected && !zone.isSelected && !device.isSelected) {
                    colour = "grey";
                    bold = false;
                }

                return (
                    <td
                        className={`${colour} large-text` + (bold ? ` bold` : ``)}
                        key={`ttt-cell-${zone._id}-${device._id}`}
                    >
            <span
                key={`ttt-value-${zone._id}-${device._id}`}
                data-tip
                data-for={`ttt-cell-${zone._id}-${device._id}`}
                className={`pointer-cursor`}
            >
              { displayAsIcons ? (
                  <span className={`glyphicon glyphicon-${triggerIcon}`} />
              ) : (
                  triggerTime?(triggerTime-zoneWindow)/1000:"N/A"
              )}
            </span>
                    </td>
                );
            });

            rowTimeList.sort((a, b) => a - b)

            const countEarly = rowTimeList.filter(time => time < 0).length
            totalEarly += countEarly

            const countOnTime = rowTimeList.filter(time => time >= 0 && time < 5000).length
            totalOnTime += countOnTime

            const countLate = rowTimeList.filter(time => time >= 5000).length
            totalLate += countLate

            let rowSummaryDisplay = [(
                <td
                    key={`ttt-summary-early-${zone._id}`}
                    className={somethingSelected && !zone.isSelected ? `grey` : `orange`}
                >
                    {countEarly}
                </td>
            ),
                <td
                    key={`ttt-summary-on-time-${zone._id}`}
                    className={somethingSelected && !zone.isSelected ? `grey` : `green`}
                >
                    {countOnTime}
                </td>,
                <td
                    key={`ttt-summary-late-${zone._id}`}
                    className={somethingSelected && !zone.isSelected ? `grey` : `red`}
                >
                    {countLate}
                </td>,
            <td>Median: {rowTimeList.length>0?rowTimeList[Math.floor(rowTimeList.length/2)]/1000:"N/A"}</td>];
fullTimeList.sort((a, b) => a - b );
            return (
                <tr key={`row-${zone._id}`}>
                    <td
                        key={`ttt-zone-name-${zone._id}`}
                        className={`clickable ${zone.isSelected || !somethingSelected ? `bold` : `grey`}`}
                        onClick={() => toggleSelectZone(zone._id)}
                    >
                        {zone.name}
                    </td>
                    {mainRowDisplay}
                    {rowSummaryDisplay}
                </tr>
            )
        });

        return (
            <table className="table table-striped">
                <thead>
                <tr key={`ttt-row-device-name`}>
                    {deviceNamesDisplay}
                </tr>
                </thead>
                <tbody>
                    {tableDisplay}
                    <tr>
                        <td>Responsiveness:</td>
                        {
                            devicesShowing.map(device =>
                                <td></td>
                            )
                        }
                        <td className="orange bold">Early: {totalEarly}/{countSingleHits} ({countSingleHits !== 0 ? (totalEarly * 100 / countSingleHits).toFixed(2) : "-" }%)</td>
                        <td className="green bold">On Time: {totalOnTime}/{countSingleHits} ({countSingleHits !== 0 ? (totalOnTime * 100 / countSingleHits).toFixed(2) : "-" }%)</td>
                        <td className="red bold">Late: {totalLate}/{countSingleHits} ({countSingleHits !== 0 ? (totalLate * 100 / countSingleHits).toFixed(2) : "-" }%)</td>
                        <td></td>
                        </tr>
                    <tr>
                        <td>Percentiles:</td>
                        <td>50%: {fullTimeList[Math.floor(fullTimeList.length*.5)]/1000}</td>
                        <td>70%: {fullTimeList[Math.floor(fullTimeList.length*.7)]/1000}</td>
                        <td>90%: {fullTimeList[Math.floor(fullTimeList.length*.9)]/1000}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

// Find the 10-second windows that contains the highest number of entries for each zone.
function calculateZoneWindows(triggers, zones, tttMetric) {
    const zoneWindows = {};
    zones.forEach(zone => {
        const triggerTimings = triggers.filter(trigger => trigger.zoneId === zone._id).map(trigger => {
            let triggerDate;
            if( tttMetric == "eventTime" )
                triggerDate = new Date(trigger.eventTime).getTime();
            else
                triggerDate = new Date(trigger.receivedAt).getTime();
            return new Date(triggerDate).getTime()
        });
        triggerTimings.sort((a, b) => a - b );
        let bestStart, bestWindowCount = -1;
        for(let i = 0; i < triggerTimings.length; i++ ) {
            let windowCount = -i*.5; // .5 is to bias zone window centre point towards earlier events
            let windowStart = triggerTimings[i];
            for( let j = i+1; j < triggerTimings.length && triggerTimings[j] < windowStart+10000; j++ ) {
                windowCount+=1
            }
            if( windowCount > bestWindowCount ) {
                bestStart = windowStart;
                bestWindowCount = windowCount;
            }
        }
        zoneWindows[zone._id] = bestStart;
    })
    return zoneWindows;
}

export default MatrixTimeToTriggerTable;